<app-top-nav></app-top-nav>
<div class="wrapper">
  <div class="header">
    <div class="filter-container">
      <div class="area-action-buttons">
        <div class="area-action-button">
          <div class="btn-group">
            <a
              aria-expanded="false"
              data-bs-toggle="dropdown"
              class="dropdown dropdown-text dropdown-toggle"
            >
              {{
                this.selectedCity === null ? "Select a city" : this.selectedCity
              }}
            </a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                (click)="clearCity()"
                *ngIf="this.selectedCity !== null"
              >
                Select a city
              </a>
              <a
                class="dropdown-item"
                *ngFor="let city of cities"
                (click)="citySelected(city)"
                data-bs-toggle="dropdown"
              >
                {{ city }}
              </a>
            </div>
          </div>
        </div>
        <div class="area-action-button">
          <div class="btn-group">
            <a
              aria-expanded="false"
              data-bs-toggle="dropdown"
              class="dropdown dropdown-text dropdown-toggle"
            >
              {{
                this.selectedFiberhood === null
                  ? "Select a FH"
                  : this.selectedFiberhood.fiberHood
              }}
            </a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                (click)="clearFiberHood()"
                *ngIf="this.selectedFiberhood !== null"
              >
                Select a FH
              </a>
              <a
                class="dropdown-item"
                *ngFor="let fiberhood of fiberhoods"
                value="{{ Id }}"
                (click)="fiberHoodSelected(fiberhood)"
              >
                {{ fiberhood.fiberHood }}
              </a>
            </div>
          </div>
        </div>
        <div class="area-action-button">
          <div class="btn-group">
            <a
              aria-haspopup="true"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              class="dropdown dropdown-text dropdown-toggle"
            >
              {{
                this.selectedBlock === null
                  ? "Select a block"
                  : this.selectedBlock.block
              }}
            </a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                (click)="clearBlock()"
                *ngIf="this.selectedBlock !== null"
              >
                Select a block
              </a>
              <a
                class="dropdown-item"
                *ngFor="let block of blockList"
                (click)="blockSelected(block)"
              >
                {{ block.block }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="inputContainer">
        <i class="fas fa-search"></i>
        <input
          [(ngModel)]="addressFilterText"
          placeholder="Search address"
          (keyup.enter)="refreshData()"
        />
      </div>
      <div class="dateFilters">
        <span class="datePicker">
          <p-calendar
            placeholder="Date from"
            inputId="fromPicker"
            dateFormat="dd/mm/yy"
            showButtonBar="true"
            [touchUI]="true"
            [readonlyInput]="true"
            [(ngModel)]="fromDate"
          >
          </p-calendar>
        </span>
        <span class="datePicker">
          <p-calendar
            placeholder="Date until"
            inputId="tillPicker"
            dateFormat="dd/mm/yy"
            showButtonBar="true"
            [touchUI]="true"
            [readonlyInput]="true"
            [(ngModel)]="tillDate"
          >
          </p-calendar>
        </span>
      </div>
      <div class="command-Types">
        <p-multiSelect
          [options]="commandTypes"
          [(ngModel)]="filterTypesCriteria"
          resetFilterOnHide="true"
          placeholder="Commands"
        ></p-multiSelect>
      </div>
      <div class="command-states">
        <p-multiSelect
          [options]="commandStates"
          [(ngModel)]="filterStatesCriteria"
          resetFilterOnHide="true"
          placeholder="States"
        ></p-multiSelect>
      </div>
    </div>
    <div class="refresh-container">
      <button (click)="clearFilter(true)" class="clear-filter-btn">
        <span class="clear-filter-text">Clear</span>
      </button>
      <button
        (click)="refreshData()"
        class="refresh-btn"
        [disabled]="!this.checkIfValid()"
      >
        <span class="refresh-text">Search</span>
      </button>
    </div>
  </div>
  <div class="body">
    <div
      class="no-fiberhood-id-wrapper"
      *ngIf="!checkIfValid() || (commands.length === 0 && !searching)"
    >
      <div class="message">
        <h5>Use the filter above to search for commands</h5>
      </div>
    </div>
    <p-table
      #dt
      [columns]="cols"
      selectionMode="single"
      [value]="commands"
      [paginator]="true"
      [rows]="25"
      [filterDelay]="250"
      autoLayout="true"
      [scrollable]="true"
      [resizableColumns]="false"
      [scrollHeight]="getScrollHeight()"
      id="table"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns"
            [class]="col.class + ' ' + 'table-header'"
            [pSortableColumn]="col.field"
          >
            {{ col.header }}
            <p-sortIcon *ngIf="col.field" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr>
          <td class="title-column">{{ item.Title }}</td>
          <td class="building-key-column">
            {{ item.CommandAddress?.BuildingLomKey }}
          </td>
          <td class="address-key-column">
            {{ item.CommandAddress?.LomKey }}
          </td>
          <td class="zoning-column">
            {{ item.Zoning }}
          </td>
          <td class="address-column">
            {{ item.CommandAddress?.FullAddress }}
          </td>
          <td>
            {{ item.LastAttempt?.StartDate | date: "dd/MM/yyy HH:mm" }}
          </td>
          <td class="state-column">{{ commandState[item.State] }}</td>

          <td class="attempts-column">
            <div
              class="icon-button"
              (click)="restartCommand(item.Id)"
              *ngIf="
                canRestartCommand()
                  && (item.State == commandState.Failed
                  || item.State == commandState.Delayed)
              "
            >
              <mat-icon class="image-rotate">keyboard_tab</mat-icon>
            </div>
            <div
              class="icon-button"
              *ngIf="
              canRetryCommand() &&
                (item.State == commandState.Failed ||
                item.State == commandState.Delayed)
              "
              (click)="retryCommand(item.Id)"
            >
              <mat-icon>redo</mat-icon>
            </div>
            <div class="icon-button" (click)="onSelectCommandDetails(item.Id)">
              <mat-icon class="material-icons-outlined">search</mat-icon>
            </div>
            <div
              class="icon-button-minimal"
              [ngClass]="{'rotate-180': !item.Collapsed}"
              (click)="item.Collapsed = !item.Collapsed"
            >
              <mat-icon>keyboard_arrow_down</mat-icon>
            </div>
          </td>
        </tr>
        <ng-container *ngIf="!item.Collapsed">
          <tr>
            <td [attr.colspan]="this.cols.length">
              <div class="row-details">
                <div class="row-details-section">
                  <span>Payload:</span>
                  <span class="details-section-text">{{ item.Payload }}</span>
                </div>
                <div
                  class="row-details-section"
                  *ngIf="item.LastAttempt.FullError"
                >
                  <span>Error:</span>
                  <span class="details-section-text">{{
                    item.LastAttempt.FullError
                  }}</span>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</div>
